<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            flat
            short
          >
            <v-toolbar-title><v-icon>mdi-lock</v-icon></v-toolbar-title>
          </v-toolbar>

          <v-card-text class="px-5 pt-5">
            <v-form
              ref="loginForm"
              autocomplete="off"
              v-if="showLoginForm"
            >    
            
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Email"
                  type="text"
                  autofocus
                  autocomplete="off"
                ></v-text-field>

                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  label="Password"
                  type="password"
                  autocomplete="off"
                  @keyup="pwdKeyup"
                ></v-text-field> 


                <v-flex mt-3 xs12>
                  <p class="text-xs-center forgotpassword">
                    <a @click.prevent="toggleForm('request-password-reset')" href="#">Reset password?</a>
                  </p>
                </v-flex>

                <v-input
                  v-if="error"
                  error-messages="Invalid credentials"
                ></v-input>
            </v-form>

            <v-form
              ref="twoFaForm"
              autocomplete="off"
              v-if="showTwoFaForm"
            >    
                <center><img :src="googleUri" alt="" /></center>

                <v-text-field
                  v-model="authCode"
                  label="Google authenticator code"
                  type="text"
                  autofocus
                  autocomplete="off"
                ></v-text-field>

                <v-input
                  v-if="error"
                  error-messages="Invalid credentials"
                ></v-input>
            </v-form>

            <v-form
              ref="requestPasswordResetFrom"
              autocomplete="off"
              v-if="showRequestPasswordResetForm"
            >   
               <v-alert v-if="emailsend"
                  type="success"
                >An e-mail has been send</v-alert>
 
                <v-text-field v-if="!emailsend"
                  v-model="eMailReset"
                  label="E-mail"
                  type="text"
                  autofocus
                  autocomplete="off"
                ></v-text-field>

                <v-input
                  v-if="error"
                  error-messages="Error"
                ></v-input>
            </v-form>

          </v-card-text>
          <v-card-actions class="px-5 pb-5">
            <v-btn v-if="showRequestPasswordResetForm||showTwoFaForm" color="primary" @click="toggleForm('login')">Back to login</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="!emailsend" color="primary" @click="doSubmit">{{ submitBtnText }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ApiService from '@/services/api.service'

export default {
  name: 'Login',
  components: {
  },
  data: () => ({
    email: '',
    password: '',

    idToken : '',
    googleUri : '',
    authCode: '',

    eMailReset: '',

    error: false,
    errors: [],

    form: 'login',

    emailsend: false,

    emailRules: [email => !!email || "Email is required"],
    passwordRules: [password => !!password || "Password is required"],

  }),
  created() {
    this.$store.dispatch('session/fullHeight', true)
    this.$store.dispatch('session/title', null)
  },
  destroyed() {
    this.$store.dispatch('session/fullHeight', false)
  },
  methods: {
    doSubmit() {
      switch(this.form) {
        case 'login':
          this.doLogin()
          break;
        case 'request-password-reset':
          this.doRequestPasswordReset()
          break;
        case 'two-fa':
          this.doTwoFaAuth()
          break;
      }
    },
    doRequestPasswordReset() {
      let route = this.$router.resolve({ name: 'reset-password'})
      this.error = false
      if (this.$refs.requestPasswordResetFrom.validate()) {
        ApiService.create('users/request-password-reset', {
          username: this.eMailReset,
          reset_password_url: `${location.origin}${route.href}`,
        }).then(() => {
          this.emailsend = true
        }).catch(() => {
          this.error = true
        })
      }
    },
    doTwoFaAuth(){
      this.error = false
      if (this.$refs.twoFaForm.validate()) {
        this.$store.dispatch('auth/login', {
          authCode: this.authCode,
          idToken: this.idToken,
        }).then(data => {
          this.googleUri = data.googleUri
          this.idToken = data.idToken
        if (this.$store.getters['auth/isLoggedIn']) {
            this.$router.push(this.$router.currentRoute.query.redirect || { name: 'dashboard' }) 
            this.$store.dispatch('language/fetch')
          } 
        }).catch(() => {
          this.error = true
        })
      }  
    },
    doLogin() {
      this.error = false
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch('auth/login', {
          username: this.email,
          password: this.password,
        }).then(data => {
          if (data.idToken) {
            this.idToken = data.idToken
            this.googleUri = data.googleUri
            this.toggleForm('two-fa')
          }
          if (this.$store.getters['auth/isLoggedIn']) {
            this.$router.push(this.$router.currentRoute.query.redirect || { name: 'dashboard' }) 
            this.$store.dispatch('language/fetch')
          } 
        }).catch((errors) => {
          this.error = true
          this.errors = errors
        })
      }
    },
    toggleForm(form) {
      this.emailsend = false;
      this.form = form
    },
    pwdKeyup(event) {
      if (event.key == "Enter") {
        this.doSubmit()
      }
    },
  },
  computed: {
    showLoginForm: function() {
      return this.form === 'login'
    },
    showRequestPasswordResetForm: function() {
      return this.form === 'request-password-reset'
    },
    showTwoFaForm: function() {
      return this.form === 'two-fa'
    },
    submitBtnText: function() {
      if (this.form == 'request-password-reset') {
        return 'Reset'
      } else {
        return 'Login'
      }
    }
  },
}
</script>